import React, { useState, useEffect } from 'react'

import ReactDataSheet from 'react-datasheet';
import 'react-datasheet/lib/react-datasheet.css';
import { videos } from '../video-list.json'

import Popup from './Popup'

const BasicSheet = () => {
    const [ modalOpen, setModalOpen ] = useState(false);
    const [ sheetData, setSheetData ] = useState({ grid: [] });
    const [ video, setVideo ] = useState({});

    useEffect(() => {
        const maxX = Math.max(...videos.map(x => x.length));
        var sheetCells = [
            [{ value: "", readOnly: true}]
        ];

        for (let x = 0; x < maxX; x++) {
            sheetCells[0].push({
                value: String.fromCharCode(64 + (x + 1)),
                readOnly: true
            });
        }

        for (let y = 0; y < videos.length; y++) {
            const rowVideos = videos[y];
            var row = [{
                value: (y + 1),
                readOnly: true
            }];

            for (let x = 0; x < maxX; x++) {
                const video = (rowVideos.length < x ? undefined : rowVideos[x]);

                row.push({
                    value: video ? video.title : "",
                    readOnly: true,
                    video: video
                })
            }
            sheetCells.push(row);
        }

        setSheetData({
            grid: sheetCells
        });
    }, [])

    return (
        <>
            <ReactDataSheet
                data={sheetData.grid}
                valueRenderer={(cell) => cell.value}
                onContextMenu={(e, cell, i, j) => 
                    cell.readOnly ? e.preventDefault() : null
                }
                onCellsChanged={changes => {
                    const grid = sheetData.grid.map(row => [...row])
                    changes.forEach(({cell, row, col, value}) => {
                        grid[row][col] = {...grid[row][col], value}
                    })
                    setSheetData({ grid: grid })
                }}
                cellRenderer={(props) => {
                    return <td 
                        style={
                            {
                                opacity: props.cell.video && props.cell.video.url ? 1 : 0.5,
                                ...(props.cell.video 
                                    ? props.cell.video.style 
                                    : undefined
                                )
                            }
                        } 
                        onMouseDown={() => {
                            if (props.cell.video) {
                                setVideo(props.cell.video);
                                setModalOpen(true);
                            }
                        }} 
                        className="cell"
                    >
                        {
                            props.cell.readOnly
                            ?
                                <>{ props.children}</>
                            :
                            <span 
                                className="value-viewer"
                            >
                                { props.children }
                            </span>
                        }
                        
                    </td>
                }}
            />
            <Popup 
                setModalOpen={setModalOpen} 
                modalOpen={modalOpen} 
                setVideo={setVideo} 
                video={video} 
            />
        </>
    )
}

export default BasicSheet